/* eslint-disable @nx/enforce-module-boundaries */
import { forwardRef, useEffect, useContext, useState } from 'react';
import {
  Box,
  HStack,
  Heading,
  IconButton,
  LinkButton,
  VStack,
  Wrap,
  WrapItem,
  useDisclosure,
} from '@mybridge/ui';
import { getLimitedDegreeConnectionsByUserId } from 'v4/store/actions/connection.actions';
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { MyNetworkUserCard } from 'v4/components/network/network-card-full';
import { MyNetworkUserCardBordered } from 'v4/components/network/network-card-new';
import { MyNetworkCircleCardMenu } from 'v4/snippets/profile/network/circle-menu';
import { NetworkChatIcon } from '@mybridge/icons';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useRouter } from 'next/router';
import { GlobalMatrixPopup } from 'v4/snippets/globalMatrixPopup';
import { getMatrixUserId, getRoomIdFromLS } from 'v4/utils/utils';
export const MyConnectionsBox = forwardRef(
  ({ active, limit, seeAll, orientation, ...props }, ref) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [confirmAction, setConfirmAction] = useState(() => () => {});
    const { userProfileInfo } = useSelector((state) => state.userProfile) ?? {};
    const dispatch = useDispatch();
    const { t } = useTranslator();
    const { push } = useRouter();
    const { startChatSingle } = useContext(MatrixContext);
    /**
     * 1st degree
     */
    const {
      data: myFirstDegreeConnections,
      refetch: refetchMyFirstDegreeConnections,
      isFetching: myFirstDegreeConnectionsIsFetching,
      isLoading: myFirstDegreeConnectionsIsLoading,
    } = useQuery({
      queryKey: ['first-degree-connections', userProfileInfo?.id],
      queryFn: async ({ queryKey, pageParam }) => {
        const resp = await dispatch(
          getLimitedDegreeConnectionsByUserId({
            userId: queryKey?.[1],
            degree: 1,
            limit: limit,
          })
        );
        return resp?.payload?.results ?? [];
      },
      refetchOnWindowFocus: false,
    });

    // useEffect(() => {
    //   refetchMyFirstDegreeConnections?.();
    // }, []);
    // eslint-disable-next-line no-unsafe-optional-chaining

    return (
      <>
        {myFirstDegreeConnections?.length ? (
          <>
            <HStack justifyContent="space-between" alignItems="center" mb={6}>
              <Heading fontSize="18px" color="#3D5A80" fontWeight="400">
                {t('profile.connections') || 'Connections'}
              </Heading>
              {seeAll && myFirstDegreeConnections?.length > 1 && (
                <LinkButton
                  color="#5B5B5B"
                  fontWeight={500}
                  fontSize="15px"
                  href="/profile/network/my-circle"
                  sx={{
                    '@media (max-width: 3100px)': {
                      marginRight: '20px'
                    },
                  }}
                >
                  {t('profile.seeAllConnections') || "See all Connections"}
                </LinkButton>
              )}
            </HStack>
            {orientation === 'table' ? (
              <Wrap>
                {myFirstDegreeConnections?.map((user, i) => (
                  <>
                    <WrapItem
                      key={user?.id}
                      minW="160px"
                      maxW={['49%', '30%', '200px']}
                      flexGrow={['1', '1', 0]}
                      flexShrink={['1', '1', 0]}
                    >
                      <MyNetworkUserCardBordered
                        user={user}
                        actions={
                          <HStack justifyContent="center">
                            {/* <IconButton
                              icon={
                                <NetworkChatIcon
                                  width="18px"
                                  height="18px"
                                  color="#9F9F9F"
                                />
                              }
                              onClick={() => startChatSingle(user)}
                            /> */}
                            <IconButton
                              icon={<NetworkChatIcon width="18px" height="18px" color="#9F9F9F" />}
                              // onClick={() => startChatSingle(cu)}
                              // onClick={(e) => {
                              //   push(`/profile/message?user=${user?.matrix_user_id}`)
                              // }}
                              onClick={() => {
                                // const matrixUserId = getMatrixUserId(user?.id);
                                
                                // if (!(user?.connection?.chat_room_id || matrixUserId)) {
                                //   setConfirmAction(() => (newId) => {
                                //     router.push(`/profile/message?user=${newId}`);
                                //   });
                                //   onOpen();
                                // } else {
                                  const roomId = getRoomIdFromLS(user?.id);
                                  push(`/profile/message?user=${roomId}`);
                                // }
                              }}
                              bg="none"
                              width="30px"
                              height="40px"
                              borderRadius="50%"
                              border="1px solid #00000033"
                            />
                            <MyNetworkCircleCardMenu user={user} />
                          </HStack>
                        }
                      />
                    </WrapItem>
                    <GlobalMatrixPopup
                      isOpen={isOpen}
                      onClose={onClose}
                      onConfirm={confirmAction}
                      selectedUserId={user?.id}
                    />
                  </>
                ))}  
              </Wrap>
            ) : (
              <HStack gap={3} align="stretch">
                {myFirstDegreeConnections?.map((user, i) => (
                  <MyNetworkUserCardBordered
                    key={user?.id}
                    user={user}
                    actions={<MyNetworkCircleCardMenu user={user} />}
                  />
                ))}
              </HStack>
            )}
          </>
        ) : (
          <></>
        )}
      </>
    );
  }
);
